module.exports = __webpack_public_path__ + "static/media/ArtsBuildOntario.57641cd4.png";